'use es6';

import { createSelector } from 'reselect';
import { getLastAuthorId } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getAllUsers = basicSelector(state => state.users);
export const getUserForLastAuthor = createSelector(getLastAuthorId, getAllUsers, (lastAuthorId, allUsers) => {
  return allUsers.find(u => u.id === lastAuthorId);
});